import update from 'immutability-helper';

import types from './types';

export const initialState = {
  summaryIntervalDuration: 3, // days TODO: remove field
};

function reducer(state, action) {
  switch (action.type) {
  case types.SET_DURATION:
    return update(state, {
      summaryIntervalDuration: { $set: action.days },
    });
  default:
    throw new Error();
  }
}

export default reducer;
